'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const viewClass = require('./view');
const modelClass = require('./model');

module.exports = createWidgetFactory({
    name: 'cash_refund',
    viewClass,
    modelClass,
    methods: {
        openRefundStatus(pnr, notificationManagerScope) {
            this.openAppSplashOverlay(pnr, notificationManagerScope);
        },
        forceRender() {
            this.render();
        },
    },
});
